// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__cOQNQ","logo-container":"Footer_logo-container__ha-+C","desc":"Footer_desc__Oflws"};